import React from 'react';
import '../../styles/Custom.css';

const CustomButtonWithStroke = ({
  text,
  type = 'button',
  onClick,
  disabled = false,
  variant = 'primary',
  icon,
  className = '',
}) => {
  const getFillColor = () => {
    switch (variant) {
      case 'primary':
        return '#000000'; // Black from SVG
      case 'google':
        return '#000'; // White for Google
      case 'apple':
        return '#000000'; // Black for Apple
      case 'danger':
        return '#7F1D1D'; // Darker red for logout
      case 'success':
        return '#166534'; // Darker green for admin
      default:
        return '#000000';
    }
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`custom-button-stroke ${variant} ${className} ${disabled ? 'disabled' : ''}`}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 464 48"
        fill="none"
        preserveAspectRatio="none"
        className="button-svg"
      >
        <path
          d="M0 6C0 2.68629 2.68629 0 6 0H447.78C449.213 0 450.598 0.512353 451.685 1.44446L461.905 10.2041C463.235 11.344 464 13.0081 464 14.7596V42C464 45.3137 461.314 48 458 48H16.2196C14.7873 48 13.4023 47.4876 12.3148 46.5555L2.09525 37.7959C0.765376 36.656 0 34.9919 0 33.2404V6Z"
          fill={getFillColor()}
        />
        <path
          d="M0.5 6C0.5 2.96243 2.96243 0.5 6 0.5H447.78C449.093 0.5 450.363 0.969657 451.36 1.82409L461.579 10.5837C462.798 11.6286 463.5 13.154 463.5 14.7596V42C463.5 45.0376 461.038 47.5 458 47.5H16.2196C14.9066 47.5 13.637 47.0303 12.6402 46.1759L2.42065 37.4163C1.20159 36.3714 0.5 34.846 0.5 33.2404V6Z"
          stroke="rgba(255, 255, 255, 0.40)"
        //   strokeOpacity="0.4"
        />
      </svg>
      <div className="button-content">
        {icon && <span className="button-icon">{icon}</span>}
        <span className="button-text">
          {text}
        </span>
      </div>
    </button>
  );
};

export default CustomButtonWithStroke;